export default "__VITE_ASSET__3c_OTdhA__"